import {
  API_BASE_PATH,
  API_PREFIX,
  SOCKET_NAMESPACE_NOTIFY,
  SOCKET_PATH_NOTIFY,
  LICENSE_KEY_MUI,
  SOCKET_PATH_RECORDS,
  SOCKET_NAMESPACE_RECORDS,
} from 'app/configs/envConfig';
import { createSlice } from '@reduxjs/toolkit';
import { getConfigFile, getConfigCompany } from './asyncThunks';

/* global __APP_VERSION__ */
/* global __APP_NAME__ */

const statusEnum = {
  BYPASS: 'bypass',
  SUCCESS: 'success',
  ERROR: 'error',
  LOADING: 'loading',
};

// ------ App Identity | Tiene la informacion del tema customizado e identidad de Company Biometrics --------
const configInitialState = {
  isLoading: true,
  status: statusEnum.BYPASS,
  errors: [],
  config: {
    name: __APP_NAME__,
    version: __APP_VERSION__,
    description: '',
    company: {
      key: undefined,
      name: undefined,
      isMultiLocation: false,
      status: true,
      metadata: {},
      step: undefined,
      email: undefined,
      phone: undefined,
      phoneCode: undefined,
      id: undefined,
    },
    location: {
      key: undefined,
      name: undefined,
      status: true,
      metadata: {},
    },
    terminal: {
      id: undefined,
      key: undefined,
      type: undefined,
      accessType: undefined,
      name: undefined,
      status: true,
      deviceId: undefined,
      modelName: undefined,
      hostname: undefined,
      macAddress: undefined,
      metadata: {},
      debug: false,
    },
    building: {
      key: undefined,
      name: undefined,
      metadata: [],
    },
    zone: {
      key: undefined,
      name: undefined,
      status: true,
      metadata: [],
      type: undefined,
    },
    roles: [
      // {
      //   name: 'Profesor',
      //   key: 'test01-role-profesor',
      //   id: '68910a409913a105510d6592',
      // },
    ],
    accessSchedules: [
      // {
      //   id: '68910c6fd23eb233e704b8c2',
      //   isRestrictAccess: false,
      //   key: 'test01-access-schedule-medio-tiempo-matutino',
      //   name: 'Medio Tiempo Matutino',
      //   exception_role_keys: [], // bypass_role_keys_access
      //   tolerancePostMin: 10,
      //   tolerancePreMin: 5,
      //   sunday: null,
      //   monday: {
      //     enable: true,
      //     end: '2025-01-01T05:59:00.000Z',
      //     isFullTime: true,
      //     start: '2024-12-31T06:00:00.000Z',
      //   },
      //   tuesday: {
      //     enable: true,
      //     end: '2024-12-31T20:00:00.000Z',
      //     isFullTime: false,
      //     start: '2024-12-31T13:00:00.000Z',
      //   },
      //   wednesday: {
      //     enable: true,
      //     end: '2024-12-31T20:00:00.000Z',
      //     isFullTime: false,
      //     start: '2024-12-31T13:00:00.000Z',
      //   },
      //   thursday: {
      //     enable: true,
      //     end: '2025-08-04T20:00:00.000Z',
      //     isFullTime: false,
      //     start: '2025-08-04T13:00:00.000Z',
      //   },
      //   friday: {
      //     enable: true,
      //     end: '2024-12-31T20:00:00.000Z',
      //     isFullTime: false,
      //     start: '2024-12-31T13:00:00.000Z',
      //   },
      //   saturday: null,
      // },
    ],
    holidays: [
      // {
      //   dateRange: 2,
      //   endDate: '2025-12-24T16:00:00.000000Z',
      //   id: '68910d0216a2afea8c0bd302',
      //   isRestrictAccess: true,
      //   key: 'test01-holiday-navidad',
      //   name: 'Navidad',
      //   startDate: '2025-12-23T16:00:00.000000Z',
      // },
    ],
    api: {
      version: undefined,
      host: API_BASE_PATH,
      prefix: API_PREFIX || '',
      token: undefined,
    },
    sockets: {
      notify: {
        host: SOCKET_PATH_NOTIFY,
        namespace: SOCKET_NAMESPACE_NOTIFY || '/',
        enable: false,
      },
      records: {
        host: SOCKET_PATH_RECORDS,
        namespace: SOCKET_NAMESPACE_RECORDS || '/',
        enable: false,
      },
      face: {
        port: 50000,
        enable: true,
        debug: true,
        deviceSelected: undefined,
        host: 'localhost:50000',
        options: {
          recognition: {
            modelName: 'Facenet',
            faceDetector: 'opencv',
            antiSpoofing: true,
            framesToProcess: 2,
            timeBetweenProcesses: 3,
            faceDistanceThreshold: 0.65,
            percentDetectionArea: 80,
            thresholdScoreVerify: 0.65,
          },
          faiss: {
            neighbors: 5,
            thresholdScoreCoincidence: 1,
          },
          camera: {
            cameraWidth: 640,
            cameraHeight: 480,
            cameraFps: 24,
            cameraRotation: 0,
            cropWidth: 360,
            cropHeight: 480,
          },
        },
      },
      finger: {
        port: 50010,
        enable: true,
        debug: true,
        deviceSelected: undefined,
        host: 'localhost:50010',
        options: {
          faiss: {
            neighbors: 5,
            thresholdScoreCoincidence: 1,
          },
        },
      },
    },
    keys: {
      muiXPro: LICENSE_KEY_MUI || undefined,
    },
  },
};

const configSlice = createSlice({
  name: 'config',
  initialState: configInitialState,
  reducers: {
    setConfigState: (state, { payload }) => ({
      ...state,
      config: payload.config,
    }),
    setConfigTerminal: (state, { payload }) => ({
      ...state,
      config: {
        ...state.config,
        terminal: payload,
      },
    }),
    resetConfig: () => configInitialState,
    setApiHost: (state, { payload }) => ({
      ...state,
      config: {
        ...state.config,
        api: payload,
      },
    }),
    setFaceDevice: (state, { payload }) => ({
      ...state,
      config: {
        ...state.config,
        sockets: {
          ...state.config.sockets,
          face: {
            ...state.config.sockets.face,
            deviceSelected: payload,
          },
        },
      },
    }),
    setFingerDevice: (state, { payload }) => ({
      ...state,
      config: {
        ...state.config,
        sockets: {
          ...state.config.sockets,
          finger: {
            ...state.config.sockets.finger,
            deviceSelected: payload,
          },
        },
      },
    }),
    setNotifySocket: (state, { payload }) => ({
      ...state,
      config: {
        ...state.config,
        sockets: {
          ...state.config.sockets,
          notify: {
            ...state.config.sockets.notify,
            ...payload,
          },
        },
      },
    }),
  },
  extraReducers: {
    [getConfigFile.pending]: (state) => {
      return { ...state, isLoading: true, errors: [], status: statusEnum.LOADING };
    },
    [getConfigFile.fulfilled]: (state, { payload }) => {
      return {
        ...state,
        isLoading: false,
        errors: [],
        status: statusEnum.SUCCESS,
        config: payload,
      };
    },
    [getConfigFile.rejected]: (state, { payload }) => {
      return { ...state, isLoading: false, errors: payload, status: statusEnum.ERROR };
    },
    // ---------- Company Info -----------
    [getConfigCompany.fulfilled]: (state, { payload }) => {
      return {
        ...state,
        config: {
          ...state.config,
          company: payload,
        },
        errors: [],
      };
    },
    [getConfigCompany.rejected]: (state, { payload }) => {
      return { ...state, errors: payload };
    },
  },
});

export default configSlice.reducer;
export const {
  setConfigState,
  resetConfig,
  setApiHost,
  setConfigTerminal,
  setFaceDevice,
  setFingerDevice,
  setNotifySocket,
} = configSlice.actions;
